import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DoctorComponent } from './call-form/doctor/doctor.component';
import { MessageComponent } from './message/message.component';
import { DocumentationComponent } from './documentation/documentation.component';
import { AppointmentCancelComponent } from './appointment/appointment-cancel/appointment-cancel.component';
import { AppPaths } from './enums/app-paths.enum';
import { SendMedicalRecordsComponent } from './medical-records/send-medical-records/send-medical-records.component';
import { RatingCallComponent } from './rate-call/rating-call/rating-call.component';
import { AddressFormComponent } from './shared/components/address-form/address-form.component';
import { ProviderBrandingResolver } from './services/provider-branding.resolver';

const routes: Routes = [
  { path: AppPaths.CALL_FORM, component: DoctorComponent },
  { path: AppPaths.DOCUMENTATION_FORM, component: DocumentationComponent },
  {
    path: AppPaths.MESSAGE,
    component: MessageComponent,
    resolve: { providerBranding: ProviderBrandingResolver },
  },
  { path: AppPaths.APPOINTMENT, children: [
    { path: AppPaths.CANCEL_FORM, component: AppointmentCancelComponent }
  ]},
  {
    path: AppPaths.MEDICAL_RECORDS_CONFIRMATION,
    component: SendMedicalRecordsComponent,
    resolve: { providerBranding: ProviderBrandingResolver },
  },
  {
    path: AppPaths.RATE,
    component: RatingCallComponent,
    resolve: { providerBranding: ProviderBrandingResolver },
  },
  {
    path: AppPaths.ADDRESS_FORM,
    component: AddressFormComponent,
    resolve: { providerBranding: ProviderBrandingResolver },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
